import { render, staticRenderFns } from "./SessionDataValues.vue?vue&type=template&id=16f31b41&scoped=true&"
import script from "./SessionDataValues.vue?vue&type=script&lang=ts&"
export * from "./SessionDataValues.vue?vue&type=script&lang=ts&"
import style0 from "./SessionDataValues.vue?vue&type=style&index=0&id=16f31b41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f31b41",
  null
  
)

export default component.exports